import makeStyles from "@material-ui/core/styles/makeStyles"
import { useTranslation } from "react-i18next"

import MuiToolbar from "@material-ui/core/Toolbar"
import Typography from "@material-ui/core/Typography"
import IconButton from "@material-ui/core/IconButton"
import Box from "@material-ui/core/Box"

import DeleteIcon from "@material-ui/icons/Delete"

const useStyles = makeStyles({
    root: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        minHeight: "unset",
        backgroundColor: "inherit"
    }
})

const AdminMultiSelectActions = props => {
    const { rows, onClickDelete } = props
    const classes = useStyles()
    const { t } = useTranslation()

    const selected = rows.filter(({ isSelected }) => isSelected)
    const totalSelected = selected.length

    if (totalSelected === 0) {
        return null
    }

    return (
        <MuiToolbar className={classes.root}>
            <Box marginRight={1}>
                <Typography variant="subtitle1" color="inherit">
                    {totalSelected} {t("view.admin.selected")}
                </Typography>
            </Box>

            <IconButton onClick={event => onClickDelete(event, selected)}>
                <DeleteIcon />
            </IconButton>
        </MuiToolbar>
    )
}

export default AdminMultiSelectActions
